/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * SelectedSystemIcon - Auto-generated from icon.js
 */
export const SelectedSystemIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g id="icon/tabbar/check/off/24">
			<path id="Vector" d="M20 6L9 17L4 12" stroke="#676767" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</g>
	</svg>
);

export default SelectedSystemIcon;
